module.exports = __webpack_public_path__ + "img/4.68a61d37.jpg";